import type { OnboardingStep } from "types/auth";

export const isWelcomeStep = (step: string) =>
  step === "welcome_pending" || step === "welcome_import_pending";

/**
 * Determines whether the ForYou queue should be loaded.
 * - Unauthenticated: always load (public queue)
 * - Authenticated + setup: don't load
 * - Authenticated + welcome/completed: load
 * - Authenticated + undefined (no useMe data): don't load
 */
export function shouldLoadForYou(
  isAuthenticated: boolean,
  onboardingStep: OnboardingStep | undefined,
): boolean {
  if (!isAuthenticated) return true;
  if (!onboardingStep) return false;
  return isWelcomeStep(onboardingStep) || onboardingStep === "completed";
}
